import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { BreadCrumb, ModalWrapper } from 'Components'
import { Key, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import './LeaseAssetDetails.scss'
import { CurrencyFormatter } from 'Helpers'
import { ToastContainer } from 'react-toastify'
import LeaseAssetService from 'Services/leaseAssetServices'
import { LeaseAssetsType } from 'Models'
import assetImg from 'Assets/Images/asset.svg'
import { LeaseAssetAgreementType } from 'Models/loanProviderTransactionType'
import { TimeConverter } from 'Helpers/TimeConverter'
import { useForm } from 'react-hook-form'

const LeaseAssetDetails = () => {
  const { id } = useParams()
  const [assetData, setAssetData] = useState<LeaseAssetsType>()
  const [aprovalReq, setAprovalReq] = useState(false)

  const [showModal, setShowModal] = useState(false)

  const { showAlert } = ShowTGAlert()

  const [previewUrl, setPreviewUrl] = useState<string | undefined>()
  const [previewType, setPreviewType] = useState<'image' | 'pdf'>('image')

  const getAsset = async () => {
    await LeaseAssetService.getSingle(id).then(
      (response) => {
        setAssetData(response.data.data)
      },
      (error: { response: { data: { error: string } } }) => {
        console.log('getPlpDetails error', error.response)
      },
    )
  }

  useEffect(() => {
    getAsset()
  }, [])

  const [updatingRequest, setUpdatingRequest] = useState(false)
  const [value, setValue] = useState(0)
  const { register, handleSubmit } = useForm<{ status: string }>()

  const submitUpdate = async (data: { status: string }) => {
    if (!id) return

    setUpdatingRequest(true)
    await LeaseAssetService.updateStatus(id, data).then(
      (response) => {
        setUpdatingRequest(false)
        showAlert({
          message: 'Update saved successfully',
          show: true,
          title: 'Success',
          type: 'success',
        })
        setShowModal(false)

        getAsset()
      },
      (error: { response: { data: { error: string } } }) => {
        setUpdatingRequest(false)
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
      },
    )
  }

  const closePreview = () => {
    setPreviewUrl(undefined)
  }

  const [agreement, setAgreement] = useState<LeaseAssetAgreementType[]>()
  const [stationCount, setStationCount] = useState<number>()

  const getLeaseAgreements = async () => {
    await LeaseAssetService.traderscardAsigned(id, 1).then((response) => {
      const dataSet = response?.data.data.dataset
      setAgreement(dataSet)
      setStationCount(dataSet.length)
    })
  }

  useEffect(() => {
    getLeaseAgreements()
  }, [])

  return (
    <div className='LeaseAssetDetails mb-5 mx-2 mx-md-0'>
      {' '}
      <div className='container mt-4'>
        <BreadCrumb
          title={'Assets'}
          parent={'Traders Card'}
          parentUrl={'lease-assets?tab=1'}
          showTitle={false}
        ></BreadCrumb>

        <div className='row mt-3'>
          <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-8 my-auto'>
            <div className='title'>
              {assetData?.displayName}
              {assetData?.status === 'APPROVED' ? (
                <span className='status-approved'>{assetData?.status}</span>
              ) : (
                <span className='status-pending'>{assetData?.status}</span>
              )}
            </div>
          </div>

          <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-md-end d-flex d-md-block'>
            {aprovalReq && (
              <button className='btn btn-respond-req'>
                <span className='spinner-border spinner-border-sm'></span>
              </button>
            )}

            <button className='btn btn-approve ms-3' onClick={() => setShowModal(true)}>
              Edit
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-7'>
            <div className='sub-title mb-2 mt-4'>Asset Details</div>
            <div className='row'>
              <div className='col-md-4'>
                <img src={assetImg} className='w-100 h-auto'></img>
              </div>
              <div className='col-md-8'>
                <div className='card border-0'>
                  <div className='card-body'>
                    <div className='list-item'>
                      <div className='label'>Interest Rate (ROI)</div>
                      <div className='value'>{assetData?.interestRatePerAnnum}% pa</div>
                    </div>
                    <div className='list-item'>
                      <div className='label'>Tenure</div>
                      <div className='value'>{assetData?.investorTenureMonths} months</div>
                    </div>
                    <div className='list-item d-flex justify-content-spacebetween'>
                      <div className='label'>Total Station Leases</div>
                      <div className='value'>{stationCount}</div>
                    </div>
                    {/* <div className='list-item'>
                      <div className='label'>Investment Starts </div>
                      <div className='value'>{assetData?.tenureStartDate}</div>
                    </div> */}
                    {/* <div className='list-item'>
                      <div className='label'>Reference</div>
                      <div className='value'>{assetData?.referenceNumber}</div>
                    </div> */}
                    <div className='list-item'>
                      <div className='label'>Valuation In Naira</div>
                      <div className='value'>
                        ₦{CurrencyFormatter(Number(assetData?.valuationInNaira))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className='card border-0 mt-3'>
              <div className='card-body balance text-center'>
                <div className='label'>Aggregated Value</div>
                <div className='value'>
                  ₦{CurrencyFormatter(assetData?.totalRealValuation ?? 0)}
                </div>
              </div>
            </div> */}
          </div>
          <div className='col-md-5'>
            <div className='sub-title mb-2 mt-4'>Aggregated Value</div>
            <div className='card border-0 mt-3'>
              <div className='card-body balance text-center'>
                {/* <div className='label'>Aggregated Value</div> */}
                <div className='value'>
                  ₦{CurrencyFormatter(assetData?.totalRealValuation ?? 0)}
                </div>
              </div>
            </div>
            {/* <div className='sub-title mb-2 mt-4'>Activity Timeline</div> 
            <div className='card border-0'>
              <div className='card-body'>
                <div className='text-center my-5'>No activity found</div>
                 <div className='list-item'>
                  <div className='label'>Agreement added</div>
                  <div className='value'>10/09/2025</div>
                </div>
                <div className='list-item'>
                  <div className='label'>Agreement added</div>
                  <div className='value'>10/09/2025</div>
                </div>
                <div className='list-item'>
                  <div className='label'>Agreement added</div>
                  <div className='value'>10/09/2025</div>
                </div>
                <div className='list-item'>
                  <div className='label'>Agreement added</div>
                  <div className='value'>10/09/2025</div>
                </div>
                <div className='list-item'>
                  <div className='label'>Agreement added</div>
                  <div className='value'>10/09/2025</div>
                </div>
                <div className='list-item'>
                  <div className='label'>Agreement added</div>
                  <div className='value'>10/09/2025</div>
                </div>
                <div className='list-item'>
                  <div className='label'>Agreement added</div>
                  <div className='value'>10/09/2025</div>
                </div>
                <div className='list-item'>
                  <div className='label'>Agreement added</div>
                  <div className='value'>10/09/2025</div>
                </div> 
              </div>
            </div> */}
          </div>
          <div className='col-md-12'>
            <div className='sub-title mb-2 mt-4'>Lease Agreements Inside</div>
            <div className='card border-0 py-3'>
              <div className='card-body'>
                <div className='table-responsive'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <td>ID</td>
                        <td>Customer</td>
                        <td>Lease Amount</td>
                        <td>Lease Duration</td>
                        <td>Lease Expiry</td>
                        <td>Lease Evaluation</td>
                        <td>Company</td>
                        <td>State</td>
                        <td>Address</td>

                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {agreement && agreement.length > 0 ? (
                        agreement.map((agree: LeaseAssetAgreementType, index: Key) => (
                          <tr key={index}>
                            <td>{agree.id}</td>
                            <td>
                              {agree.customer?.firstName ?? ''} {agree.customer?.lastName ?? ''}
                            </td>
                            <td>{CurrencyFormatter(agree.stationLeaseAmountMajor ?? 0)}</td>
                            <td>{agree.stationLeaseDurationMonths}</td>
                            <td>{TimeConverter(agree.stationLeaseExpiryDate)}</td>
                            <td>{CurrencyFormatter(agree.stationLeaseValuationMajor)}</td>
                            <td>{agree.companyName}</td>
                            <td>{agree.state}</td>
                            <td>{agree.companyAddress}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={9} className='text-center'>
                            No agreement found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalWrapper
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        title='Updated Asset'
        hideHeader={false}
      >
        <form onSubmit={handleSubmit(submitUpdate)}>
          <div className='form-input'>
            <label htmlFor='asset' style={{ fontSize: '.7rem' }}>
              Status
            </label>
            <select className='form-control' {...register('status')}>
              <option value={''}>select</option>
              <option selected={assetData?.status === 'PENDING' ? true : false}>PENDING</option>
              <option selected={assetData?.status === 'AVAILABLE' ? true : false}>AVAILABLE</option>
              <option selected={assetData?.status === 'SOLD' ? true : false}>SOLD</option>
            </select>
          </div>

          <div className='form-input mt-3'>
            <button className='btn btn-default w-100 py-2' type='submit'>
              Update {updatingRequest && <span className='spinner-border spinner-border-sm'></span>}
            </button>
          </div>
        </form>
      </ModalWrapper>
      <ModalWrapper
        showModal={previewUrl != undefined}
        closeModal={() => closePreview()}
        title='Document Preview'
        hideHeader={false}
        size={'xl'}
      >
        {previewType === 'image' ? (
          <img
            src={previewUrl}
            alt='Preview'
            className='img-fluid rounded'
            style={{ maxHeight: '75vh' }}
          />
        ) : (
          <iframe src={previewUrl} title='PDF Preview' width='100%' height='600px'></iframe>
        )}
      </ModalWrapper>
      <ToastContainer></ToastContainer>
    </div>
  )
}

export default LeaseAssetDetails
